import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '@/store/index'

const selectAgencyUsersUiState = (state: RootState) => state.agencyUsersUi

export const selectAgencyUserFormMode = createSelector(
  selectAgencyUsersUiState,
  (ui) => ui.mode,
)

export const selectAgencyUserFormAgencyId = createSelector(
  selectAgencyUsersUiState,
  (ui) => ui.agencyId,
)

export const selectEditingAgencyUserId = createSelector(
  selectAgencyUsersUiState,
  (ui) => ui.editingUserId,
)

export const selectAgencyUserFormFields = createSelector(
  selectAgencyUsersUiState,
  (ui) => ui.fields,
)

export const selectAgencyUserFormFieldErrors = createSelector(
  selectAgencyUsersUiState,
  (ui) => ui.fieldErrors,
)

export const selectAgencyUserFormSubmitError = createSelector(
  selectAgencyUsersUiState,
  (ui) => ui.submitError,
)

export const selectIsAgencyUserFormSubmitting = createSelector(
  selectAgencyUsersUiState,
  (ui) => ui.isSubmitting,
)

export const selectIsAgencyUserFormOpen = createSelector(
  selectAgencyUserFormMode,
  (mode) => mode !== 'closed',
)
